<template lang="pug">
  .component-vat-amount-toggler
    label {{label}}
      input(type="text", v-model="amount", @input="setAmount")
      .help-text {{$priceWithcurrency(recordAmount)}} included vat
    label Included vat &nbsp;
      input(type="checkbox", v-model="vat")
</template>

<script>
  export default {
    name: 'VatAmountToggler',
    watch: {
      vat() {

        this.$emit('input', this.vatAmount)
      },
      tax() {
        this.$emit('input', this.vatAmount)
      }
    },
    data() {
      return {
        vat: false,
        amount: 0
      }
    },
    created() {
      this.amount = this.value
    },
    methods: {
      setAmount() {
        this.$emit('input', this.vatAmount)
      }
    },
    computed: {
      recordAmount() {
        if (this.vat === false) {
          const tax = this.tax !== '' || this.tax === 0 ? this.tax : null
          return this.$priceWithVat(this.amount, tax)
        }
        return this.amount
      },
      vatAmount() {
        return this.$vatPart(this.recordAmount, parseFloat(this.tax))
      }
    },
    props: {
      label: {
        type: String,
        required: true
      },
      value: {
        required: true
      },
      tax: {},
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// VatAmountToggler.vue?7f368021